import { isToday } from "date-fns";
import type { AppointmentStatus } from "@bookdental/schemas";
import { useAuth } from "./auth";

const ANTES_DE_CHEGAR: AppointmentStatus[] = ["SCHEDULED", "CONFIRMED", "LATE"];

/** "Paciente chegou" é o botão do balcão: só a Recepção vê, e só em consulta de hoje que ainda espera
 *  a chegada. Os demais papéis mudam o status pela lista de sempre. */
export function usePodeMarcarChegada() {
  const { user } = useAuth();
  const recepcao = user?.activeOrganization?.role === "RECEPTIONIST";
  return (status: AppointmentStatus, date: string | Date) =>
    recepcao && ANTES_DE_CHEGAR.includes(status) && isToday(new Date(date));
}
